import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

class CashVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
  }

  _date = (d) => {
    let str = "";
    if (d !== null) {
      let i = d.indexOf(" ");
      str = d.substring(0, i);
    }
    return str;
  };

  _img = (m, l) => {
    let img = "";
    let _defaultImg = () => {
      if (l) {
        //LOLOL
        img = require("../../assets/img/lolol_cash_voucher.png");
      } else {
        //MERCHANT
        img = require("../../assets/img/merchant_cash_voucher.png");
      }
    };

    if (m.length !== 0) {
      m.forEach((d, i) => {
        if (d.path) {
          img = d.path;
        } else {
          _defaultImg();
        }
      });
    } else {
      _defaultImg();
    }

    return img;
  };
  _availableTime = (t) => {
    let arr = [];
    let available_time = "";
    if (t === "[]") {
      arr.push({ times: "All Day Available" });
      available_time = arr[0].times;
      return (
        <div className="available-time">
          <p className="time">{available_time}</p>
        </div>
      );
    } else {
      JSON.parse(t).forEach((d, i) => {
        arr.push({ times: d, no: i });
      });
      return (
        <div className="available-time">
          {arr.length === 1 &&
            arr.map((v, idx) => {
              return (
                <p className="time" key={idx}>
                  {v.times}
                </p>
              );
            })}
          {arr.length > 1 &&
            arr.slice(0, 1).map((v, idx) => {
              return (
                <p className="time" key={idx}>
                  {v.times}
                  {idx === 0 ? "..." : null}
                </p>
              );
            })}
        </div>
      );
    }
  };

  _icon = (l) => {
    let img = "";
    if (l) {
      img = require("../../assets/img/lolol_cash_icon.png");
    } else {
      img = require("../../assets/img/merchant_cash_icon.png");
    }
    return img;
  };

  _hover = () => {
    let hover = "";
    if (this.props.onClick !== undefined) {
      hover = "hover";
    }
    return hover;
  };

  _onclick = (data) => {
    if (this.props.onClick !== undefined) {
      this.props.onClick(data);
    }
  };

  _expired = (d) => {
    const { m_data } = this.props;
    let expired = false;
    let today = new Date();
    let dateNow = moment(today).format("YYYY-MM-DD HH:mm:ss");
    if (m_data === undefined) {
      let dateEnd = moment(d.publish_end)._i;
      if (dateEnd < dateNow) {
        expired = true;
      }
    } else {
      let dateEnd = moment(d.package_use_date_end)._i;
      if (dateEnd < dateNow && m_data.status !== 3) {
        expired = true;
      }
    }
    return expired;
  };

  _checkRefundRedeemExpired = () => {
    const { m_data } = this.props;
    if (m_data !== undefined && m_data.voucher_id !== undefined) {
      let text = "";
      let img = "";
      // My Voucher
      switch (m_data.status) {
        case 2:
          text = "redeemed";
          img = require("../../assets/img/redeemed-chop.png");
          break;
        case 3:
          text = "expired";
          img = require("../../assets/img/expired-chop.png");
          break;
        case 4:
          text = "refunded";
          img = require("../../assets/img/refunded-chop.png");
          break;
        default:
          text = "";
          break;
      }
      if (text !== "") {
        return (
          <div className={`${text} chop circle mb-3`}>
            <img className="image" alt={text} src={img} />
          </div>
        );
      }
    }
  };

  _checkBox = () => {
    let checkBox = "";
    if (this.props.checkBox !== undefined) {
      checkBox = "checkBox";
    }
    return checkBox;
  };

  _availableVoucher = () => {
    let available = "";
    if (this.props.unavailable) {
      available = "unavailable";
    }
    return available;
  };

  _checkBoxSelect = (data) => {
    this.setState({
      selected: !this.state.selected,
    });
  };

  _activeCheckBox = () => {
    let select = "";
    if (this.state.selected) {
      select = "select";
    }
    return select;
  };

  _percentage = (d) => {
    let percentage = "";
    percentage = ((d.item_price - d.package_price) / d.item_price) * 100;
    return "-" + parseInt(percentage) + "%";
  };

  _title = (d) => {
    let title = "";
    if (this.props.get && !this.props.shortTitle) {
      title = d;
    } else if (d.length > 20) {
      let str = d;
      title = str.substring(0, 20) + "...";
    } else {
      title = d;
    }
    return title;
  };

  _soldOut = (d) => {
    let soldOut = false;
    if (d.quantity > 0 && d.sales > d.quantity) {
      soldOut = true;
    } else {
      soldOut = false;
    }
    return soldOut;
  };
  _renderMinSpend = () => {
    const { data } = this.props;
    if (data.package_type === "V") {
      let package_data = JSON.parse(data.package_menu);
      let min_spend_text = "";
      if (package_data["over"] === undefined) {
        package_data["over"] = 0;
      }
      min_spend_text =
        "Min Spend RM" + parseFloat(package_data["over"]).toFixed(2);
      return (
        <div>
          <p>{min_spend_text}</p>
        </div>
      );
    }
    return null;
  };
  _renderApplicableTo = () => {
    const { data } = this.props;

    let applicable_restaurant = null;
    let applicable_text = null;

    try {
      applicable_restaurant = JSON.parse(data.applicable_restaurant);

      if (applicable_restaurant.length !== 0) {
        let total_shop = 0;
        let applicable_to = [];
        let applicable_all = false;

        applicable_restaurant.forEach((data) => {
          switch (data) {
            case "all":
              applicable_all = true;
              break;
            case "mall":
              applicable_to.push("Mall");
              break;
            case "bus_ticket":
              applicable_to.push("Bus Ticket");
              break;
            case "m_prepaid":
              applicable_to.push("Mobile Prepaid");
              break;
            case "m_postpaid":
              applicable_to.push("Mobile Postpaid");
              break;
            case "games_gift":
              applicable_to.push("Games Gift");
              break;
            default:
              total_shop += 1;

              break;
          }
        });

        if (!applicable_all) {
          if (applicable_to.length !== 0) {
            applicable_text = `Only applicable to ${applicable_to.join(", ")}`;
          } else {
            applicable_text = ` Applicable to ${total_shop} ${
              total_shop === 1 ? "shop" : "shops"
            } `;
          }
        }

        return (
          applicable_text !== null && (
            <div>
              <p className="applicable">{applicable_text}</p>
            </div>
          )
        );
      }
    } catch (error) {
      //   console.log("Failed to parse applicable restaurant");
    }

    return null;
  };

  render() {
    const { data, type, checkBox, checkBoxValue } = this.props;

    return data.length !== 0 && type === "V" ? (
      <React.Fragment>
        <div
          className={`outer-div ${this._checkBox()} ${this._activeCheckBox()} ${this._availableVoucher()}`}
          onClick={() => this._onclick(data)}
          style={this.props.addStyle}
        >
          <div
            className={`background ${this._hover()}`}
            style={{
              backgroundImage: `url(
                      ${this._img(data.Media, data.lolol_voucher)}

                    )`,
            }}
          />
          {/* Checkbox*/}
          {checkBox !== undefined && (
            <div className="c-box">
              <label>
                <input
                  type="checkbox"
                  name={data.specialPackage_id}
                  checked={checkBoxValue}
                  // checked={this.state.check}
                  // onChange={this._checkBoxSelect}
                  onChange={(e) => {
                    e.stopPropagation();
                    this.props.onChangeCheckbox(e);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                <span className="checkmark" />
              </label>
            </div>
          )}
          {/* Discount Percentage */}
          <div className="discount">
            <span>{this._percentage(data)}</span>
          </div>
          {data.soldOut === 1 && (
            <div className="sold-out chop circle">
              <img
                className="image"
                alt="sold-out"
                src={require("../../assets/img/sold-out-chop.png")}
              />
            </div>
          )}
          {this._expired(data) && (
            <div className="expired tag circle">
              <span>expired</span>
            </div>
          )}
          {this._checkRefundRedeemExpired()}
          <div className="contain">
            <div className="info">
              {/* Package Icon */}
              <div className="icon alignment">
                <img alt="icon" src={`${this._icon(data.lolol_voucher)}`} />
              </div>
              <div className="summary alignment">
                {/* Package Title */}
                <h5 className="title">{this._title(data.package_title)}</h5>
                {/*Package Use Date */}
                <div className="d-flex">
                  <p>{this._date(data.package_use_date_start)}</p>
                  <p className="px-1"> - </p>
                  <p>{this._date(data.package_use_date_end)}</p>
                </div>
                {/*Available time */}
                {this._availableTime(data.package_use_times)}
                {/* Price */}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="d-block item-price">RM {data.item_price}</p>
                    <p className="d-block "> Sales {data.sales} </p>
                  </div>
                  <h5 className="package-price">RM {data.package_price}</h5>
                </div>
                {this._renderApplicableTo()}
                {this._renderMinSpend()}
              </div>
            </div>
          </div>
          {this.props.get ? (
            <div className="d-flex d-sm-block">
              <Button
                className={`mt-2`}
                variant="primary"
                block
                onClick={this.props.getPromo}
              >
                GET PROMO VOUCHER
              </Button>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    ) : null;
  }
}

CashVoucher.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  checkBox: PropTypes.bool,
  checkBoxValue: PropTypes.bool,
  unavailable: PropTypes.bool,
  vid: PropTypes.number,
  // Function
  onClick: PropTypes.func,
  onChangeCheckbox: PropTypes.func,
};

export default CashVoucher;
